module.exports = __webpack_public_path__ + "static/img/7.590e909.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/8/1/3/zh/7.png
// module id = igZF
// module chunks = 0